import { Box } from "@mui/material";
import { InfoSection } from "../../components/common/infoSection";
import type { Tenant } from "../../types/deal";

import { dateFormatter, dateTimeFormatter, numberFormatter } from "../../utils/numberFormatter";

interface TenantDetailSectionProps {
    tenant: Tenant;
    isEdit: boolean;
  }

export const TenantDetail = ({ tenant } : TenantDetailSectionProps) => {

    return (
        <Box sx={{ display: 'flex', gap: '10px', flexDirection: 'column', width: '100%' }}>
            
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        <InfoSection
            title="Lease Info"
            items={[
            { label: "Asset name", value: tenant.asset?.asset_name, link: `/assets/${tenant.asset?.id}` },
            { label: "Tenant name", value: tenant.tenant_name },
            { label: "Tenant Sector", value: tenant.tenant_sector },
            { label: "Currency", value: tenant.rent_currency },
            { label: "Created At", value: dateTimeFormatter({ value: tenant.created_at }) },
            { label: "Updated At", value: dateTimeFormatter({ value: tenant.updated_at })},
            ]}
        />
        <InfoSection
            title="Lease Details"
            items={[
            { label: "Lease Start Date", value: dateFormatter({ value: tenant.lease_start_date })},
            { label: "Lease End Date", value: dateFormatter({ value: tenant.lease_end_date })},
            { label: "Lease Break Date", value: dateFormatter({ value: tenant.break_option_date })},
            { label: "Next Review Date", value: dateFormatter({ value: tenant.next_review_date })},
            { label: "Contracted Rent", value: numberFormatter({ value: tenant.contracted_rent }) },
            { label: "Passing Rent", value: numberFormatter({ value: tenant.passing_rent }) },
            { label: "Rent Free Amount", value: numberFormatter({ value: tenant.rent_free_amount }) },
            { label: "Rent Free End Date", value: dateFormatter({ value: tenant.rent_free_end_date })},
            { label: "Rent Currency", value: tenant.rent_currency },
            { label: "Unit Type", value: tenant.unit_type },
            { label: "Total Area", value: numberFormatter({ value: tenant.total_area }) },
            { label: "Area Type", value: tenant.area_type },
            { label: "Estimated Rental Value", value: numberFormatter({ value: tenant.estimated_rental_value }) },
            { label: "TF ERV", value: numberFormatter({ value: tenant.tf_erv }) },
            { label: "No. of Parking Spaces", value: numberFormatter({ value: tenant.count_parking }) },
            { label: "Parking ERV", value: numberFormatter({ value: tenant.parking_erv }) },
            { label: "Parking Income", value: numberFormatter({ value: tenant.parking_income }) },
            { label: "IOS Area", value: numberFormatter({ value: tenant.ios_area }) },
            { label: "IOS ERV", value: numberFormatter({ value: tenant.ios_erv }) },
            { label: "IOS Income", value: numberFormatter({ value: tenant.ios_income }) },
            ]}
        />
        </Box>
        </Box>
    );
    }
    